import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'

axios.defaults.withCredentials = true
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: () =>
      import(/* webpackChunkName: "Login" */ '../views/Login.vue')
  },
  {
    path: '/master',
    name: 'Template',
    component: () =>
      import(/* webpackChunkName: "Template" */ '../views/Template.vue'),
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () =>
          import(/* webpackChunkName: "Dashboard" */ '../views/Dashboard.vue')
      },
      {
        path: '/whiteboard',
        name: 'WhiteBoard',
        component: () =>
          import(/* webpackChunkName: "WhiteBoard" */ '../views/whiteBoard/show.vue')
      },
      {
        path: '/profile',
        name: 'Profile',
        component: () =>
          import(/* webpackChunkName: "Profile" */ '../views/profile.vue')
      },
      {
        path: '/staff/create',
        name: 'staff.create',
        component: () =>
          import(/* webpackChunkName: "staff.create" */ '../views/staff/create.vue')
      },
      {
        path: '/staff/edit/:id',
        name: 'staff.edit',
        props: true,
        component: () =>
          import(/* webpackChunkName: "staff.edit" */ '../views/staff/edit.vue')
      },
      {
        path: '/staff/reports/:id',
        name: 'staff.reports',
        props: true,
        component: () =>
          import(/* webpackChunkName: "staff.reports" */ '../views/staff/reports.vue')
      },
      {
        path: '/staff/reports/:id/:date',
        name: 'staff.reports.print',
        props: true,
        component: () =>
          import(/* webpackChunkName: "staff.report.print" */ '../views/staff/print.vue')
      },
      {
        path: '/staff/index',
        name: 'staff.index',
        component: () =>
          import(/* webpackChunkName: "staff.index" */ '../views/staff/index.vue')
      },
      {
        path: '/portfolio',
        name: 'portfolio.index',
        component: () =>
          import(/* webpackChunkName: "portfolio.index" */ '../views/portfolio/index.vue')
      },
      {
        path: '/portfolio/edit/:id',
        name: 'portfolio.edit',
        props: true,
        component: () =>
          import(/* webpackChunkName: "portfolio.edit" */ '../views/portfolio/edit.vue')
      },
      {
        path: '/portfolio/create',
        name: 'portfolio.create',
        component: () =>
          import(/* webpackChunkName: "portfolio.create" */ '../views/portfolio/create.vue')
      },
      {
        path: '/permissions',
        name: 'permissions.index',
        component: () =>
          import(/* webpackChunkName: "permissions.index" */ '../views/permissions/index.vue')
      },
      {
        path: '/permissions/create',
        name: 'permissions.create',
        component: () =>
          import(/* webpackChunkName: "permissions.create" */ '../views/permissions/create.vue')
      },
      {
        path: '/permissions/edit/:id',
        name: 'permissions.edit',
        props: true,
        component: () =>
          import(/* webpackChunkName: "permissions.edit" */ '../views/permissions/edit.vue')
      },
      {
        path: '/vacations',
        name: 'vacations.index',
        component: () =>
          import(/* webpackChunkName: "vacations.index" */ '../views/vacations/index.vue')
      },
      {
        path: '/roles',
        name: 'roles.index',
        component: () =>
          import(/* webpackChunkName: "roles.index" */ '../views/roles/index.vue')
      },
      {
        path: '/roles/create',
        name: 'roles.create',
        component: () =>
          import(/* webpackChunkName: "roles.create" */ '../views/roles/create.vue')
      },
      {
        path: '/roles/edit/:id',
        name: 'roles.edit',
        props: true,
        component: () =>
          import(/* webpackChunkName: "roles.edit" */ '../views/roles/edit.vue')
      },
      {
        path: '/materials',
        name: 'materials.index',
        component: () =>
          import(/* webpackChunkName: "materials.index" */ '../views/materials/index.vue')
      },
      {
        path: '/notices',
        name: 'notices.index',
        component: () =>
          import(/* webpackChunkName: "notices.index" */ '../views/notice/index.vue')
      },
      {
        path: '/installers',
        name: 'installers.index',
        component: () =>
          import(/* webpackChunkName: "installers.index" */ '../views/installers/index.vue')
      },
      {
        path: '/installers/create',
        name: 'installers.create',
        component: () =>
          import(/* webpackChunkName: "installers.create" */ '../views/installers/create.vue')
      },
      {
        path: '/installers/edit/:id',
        name: 'installers.edit',
        props: true,
        component: () =>
          import(/* webpackChunkName: "installers.edit" */ '../views/installers/edit.vue')
      },
      {
        path: '/installer/:id/projects',
        name: 'installer.projects',
        props: true,
        component: () =>
          import(/* webpackChunkName: "installer.projects" */ '../views/installers/projects.vue')
      },
      {
        path: '/installer/:id/reports',
        name: 'installer.reports',
        props: true,
        component: () =>
          import(/* webpackChunkName: "installer.reports" */ '../views/installers/reports.vue')
      },
      {
        path: '/installer/:id/reports/history',
        name: 'installer.reports.history',
        props: true,
        component: () =>
          import(/* webpackChunkName: "installer.reports.history" */ '../views/installers/reportsHistory.vue')
      },
      {
        path: '/installer/:id/report/history/:pdf',
        name: 'installer.history.report',
        props: true,
        component: () =>
          import(/* webpackChunkName: "installer.history.report" */ '../views/installers/reports.vue')
      },
      {
        path: '/sms',
        name: 'sms.index',
        component: () =>
          import(/* webpackChunkName: "sms.index" */ '../views/sms/index.vue')
      },
      {
        path: '/sms/create',
        name: 'sms.create',
        component: () =>
          import(/* webpackChunkName: "sms.create" */ '../views/sms/create.vue')
      },
      {
        path: '/projects',
        name: 'projects.index',
        component: () =>
          import(/* webpackChunkName: "projects.index" */ '../views/projects/index.vue')
      },
      {
        path: '/projects/create',
        name: 'projects.create',
        component: () =>
          import(/* webpackChunkName: "installers.create" */ '../views/projects/create.vue')
      },
      {
        path: '/projects/show/:id',
        name: 'projects.show',
        props: true,
        component: () =>
          import(/* webpackChunkName: "installers.edit" */ '../views/projects/show.vue')
      },
      {
        path: '/customers',
        name: 'customers.index',
        component: () =>
          import(/* webpackChunkName: "customers.index" */ '../views/customers/index.vue')
      },
      {
        path: '/customer/:id/projects',
        name: 'customer.projects',
        component: () =>
          import(/* webpackChunkName: "customer.projects" */ '../views/customers/projects.vue')
      },
      {
        path: '/monitorings',
        name: 'monitorings.index',
        component: () =>
          import(/* webpackChunkName: "monitorings.index" */ '../views/monitorings/index.vue')
      },
      {
        path: '/reports',
        name: 'reports.index',
        component: () =>
          import(/* webpackChunkName: "reports.index" */ '../views/reports/reports.vue')
      },
      {
        path: '/ticket',
        name: 'ticket',
        component: () =>
          import(/* webpackChunkName: "ticket" */ '../views/ticket.vue')
      },
      {
        path: '/chat',
        name: 'chat',
        component: () =>
          import(/* webpackChunkName: "ticket" */ '../views/chat.vue')
      },
      // {
      //   path: '/factor',
      //   name: 'factor',
      //   component: () =>
      //     import(/* webpackChunkName: "factor" */ '../views/factor.vue')
      // },
      {
        path: '/403',
        name: '403',
        component: () =>
          import(/* webpackChunkName: "403" */ '../views/403.vue')
      },
      {
        path: '/*',
        alias: '*',
        name: 'notFound',
        component: () =>
          import(/* webpackChunkName: "NotFound" */ '../views/NotFound')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  linkExactActiveClass: 'is-active',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (localStorage.getItem('isLoggedIn')) {
    axios.get('/api/user').catch(errors => {
      localStorage.removeItem('isLoggedIn')
      localStorage.removeItem('name')
      next({ name: 'Login' })
    })
  }
  if (to.name !== 'Login' && !localStorage.getItem('isLoggedIn')) next({ name: 'Login' })
  if (to.name === 'Login' && localStorage.getItem('isLoggedIn')) {
    next({ name: 'Dashboard' })
  }
  if (to.name === 'Template') {
    next({ name: 'Dashboard' })
  } else next()
})

export default router
